module.exports = __webpack_public_path__ + "img/kv.dae63c8d.jpg";